// import Lottie from 'react-lottie';
// import textanimation from "../assets/loader.json"
// const Loader = () => {
//     const defaultOptions = {
//         loop: false,
//         autoplay: true,
//         animationData: textanimation,
//         rendererSettings: {
//             preserveAspectRatio: "xMidYMid slice"
//         }
//     };

//     return (

//         <div className='w-full h-full fixed top-0 grid place-items-center ' >
//             <Lottie options={defaultOptions}

//             />

//         </div>
//     )
// }

// export default Loader
import Rive, { Alignment, Fit, Layout } from '@rive-app/react-canvas'

const Loader = () => {
  return (
    <div className=' min-w-screen relative min-h-screen w-full h-full'>
      <Rive
        src='/assets/uniten_logo.riv'
        autoPlay
        className='absolute inset-0 grid place-items-center loading [&>canvas]:!w-full [&>canvas]:!h-full'
        style={{ width: '100%', height: '100%' }}
        layout={new Layout({
            fit: Fit.Cover,
            alignment: Alignment.Center
          })}
      />
    </div>
  )
}

export default Loader
